import "./profession-item.css";

export default function ProfessionItem({ label, onDelete, disabled = false }) {
   const handleClick = () => {
      if (!disabled && onDelete) onDelete();
   };

   return (
      <div className="profession-item"> 
         <span
            style={{ 
               cursor: disabled ? "not-allowed" : "pointer",
               opacity: disabled ? 0.4 : 1
            }}
            aria-disabled={disabled}
            onClick={ handleClick }
            title={disabled ? "Musi pozostać co najmniej 1 zawód" : "Usuń zawód"}
         > 
            <svg className="stroke" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M1 1.5L13 13.5" strokeWidth="2" strokeLinecap="round"/>
               <path d="M13 1.5L1 13.5" strokeWidth="2" strokeLinecap="round"/>
            </svg>
         </span>

         { label }
      </div>
   )
}